import React from 'react';
import ContentContainer from '../../BuildingBlocks/Container/ContentContainer';
import Typography from '@material-ui/core/Typography';
import NextButton from '../../SubmitApplication/NextButton';
import { useEventTrackerContext } from 'frontend/src/contexts/EventTracker';

export default function ConnectOtherPlatformAccount({ goForward }) {
  const { trackEvent } = useEventTrackerContext();

  async function handleSubmit() {
    trackEvent({
      event: 'click_next_other_account',
    });
    goForward();
  }

  return (
    <ContentContainer width={600}>
      <Typography paragraph>
        Our team will contact you soon on how to connect our team to your
        platform.
      </Typography>
      <Typography paragraph>Until then, let's continue.</Typography>
      <NextButton onClick={handleSubmit} isPrimary={true} />
    </ContentContainer>
  );
}
